// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50;position:relative;width:100%;height:100dvh;background-color:#fff;overflow:hidden}.body-content{margin-right:50px;padding-right:15px;padding-left:15px;width:100%}.right-toolbar{width:50px;height:100%;position:fixed;right:0;border:1px solid grey}.mail-container{width:100%;margin-right:auto;margin-left:auto}.mail-wrap{display:flex;flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
